// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__21WQk","tab":"Tabs_tab__2t_Bp","tabActive":"Tabs_tabActive__2ja2A"};